import { render } from "./activate.vue?vue&type=template&id=56f84611&scoped=true"
import script from "./activate.vue?vue&type=script&lang=js"
export * from "./activate.vue?vue&type=script&lang=js"

import "./activate.vue?vue&type=style&index=0&id=56f84611&scoped=true&lang=css"

import exportComponent from "/appwd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f84611"]])

export default __exports__